import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AuthChoicePanel from '../../../auth/ui/components/AuthChoicePanel';
import { useAuthState } from '../../../auth/domain/useAuthState';

export default function ReaderAuthGatePage() {
  const { id } = useParams();
  const nav = useNavigate();
  const loc = useLocation();
  const { loading, isAuthenticated } = useAuthState();
  const nextPath = id ? `/g/${id}${loc.search || ''}` : '/stories';

  useEffect(() => {
    if (!id) {
      nav('/stories', { replace: true });
      return;
    }

    if (!loading && isAuthenticated) {
      nav(nextPath, { replace: true });
    }
  }, [id, isAuthenticated, loading, nav, nextPath]);

  if (!id || (!loading && isAuthenticated)) {
    return null;
  }

  return (
    <AuthChoicePanel
      nextPath={nextPath}
      eyebrow="Chapter access"
      title="Sign in to continue reading"
      description="This chapter requires authentication. Choose the provider you want to use and we will bring you right back to this page."
    />
  );
}
